var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-container',[_c('el-aside',{attrs:{"width":"300px"}},[_c('NavMenu')],1),_c('div',{staticClass:"zhankeng",staticStyle:{"display":"inline-block","width":"300px"}}),_c('el-container',[_c('el-header',[_c('NavBar',{attrs:{"username":_vm.username}})],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }